function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { forwardRef } from 'react';
import { su, theme } from '@arc/frontend/ui-theme';
const hubButtonBaseStyle = /*#__PURE__*/css(su.fontSans, su.roundedMd, {
  height: '2.5rem',
  /* @todo The shadow sticks when a button is clicked because it becomes focused. This looks odd. */
  '&:hover, &:focus': /*#__PURE__*/css(su.shadow, "outline:none;" + (process.env.NODE_ENV === "production" ? "" : ";label:--hover----focus;")),
  '&:not(:disabled, [data-disabled=true]):active': {
    /* @todo We would like the text of a button to not darken. */
    filter: 'brightness(81%)'
  },
  '&:disabled, &[data-disabled=true]': process.env.NODE_ENV === "production" ? {
    name: "1tcgq7c",
    styles: "box-shadow:none;cursor:default"
  } : {
    name: "15339su---disabled----data-disabled-true-",
    styles: "box-shadow:none;cursor:default;label:--disabled----data-disabled-true-;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:hubButtonBaseStyle;");
const variants = {
  contained: color => /*#__PURE__*/css({
    border: 'none',
    backgroundColor: theme.colors.palettes[color].main,
    color: theme.colors.palettes[color].contrastText,
    '&:disabled, &[data-disabled=true]': {
      backgroundColor: theme.colors.action.disabledBackground
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:contained;"),
  outlined: color => /*#__PURE__*/css({
    border: '1px solid',
    borderColor: theme.colors.palettes[color].main,
    color: theme.colors.palettes[color].dark,
    backgroundColor: theme.colors.background.paper,
    '&:disabled, &[data-disabled=true]': {
      borderColor: theme.colors.action.disabledBackground,
      color: theme.colors.text.hint
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:outlined;")
};
const sizes = {
  regular: process.env.NODE_ENV === "production" ? {
    name: "19yz2oq",
    styles: "padding-left:1rem;padding-right:1rem;min-width:5.75rem"
  } : {
    name: "1ifxoao-regular",
    styles: "padding-left:1rem;padding-right:1rem;min-width:5.75rem;label:regular;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  small: process.env.NODE_ENV === "production" ? {
    name: "13ctlgx",
    styles: "padding-left:0.5rem;padding-right:0.5rem;min-width:5.6rem"
  } : {
    name: "p111ek-small",
    styles: "padding-left:0.5rem;padding-right:0.5rem;min-width:5.6rem;label:small;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  xsmall: /*#__PURE__*/css(su.textXs, "display:flex;align-items:center;justify-content:center;padding-left:0.5rem;padding-right:0.5rem;min-width:5rem;height:1.75rem;" + (process.env.NODE_ENV === "production" ? "" : ";label:xsmall;"))
};
export const hubButtonStyle = ({
  color = 'primary',
  variant = 'outlined',
  size = 'regular'
}) => /*#__PURE__*/css(hubButtonBaseStyle, variants[variant](color), sizes[size], process.env.NODE_ENV === "production" ? "" : ";label:hubButtonStyle;");
export const Button = forwardRef(
// eslint-disable-next-line @typescript-eslint/no-shadow
function Button({
  color,
  variant,
  size,
  ...buttonProps
}, ref) {
  return <button ref={ref} css={hubButtonStyle({
    color,
    variant,
    size
  })} type="button" {...buttonProps} />;
});